<template>
  <!-- PRODUCT PAGE -->
  <section class="section-product-page bg-grey pt-5">
    <div class="container page-container">

      <div class="content">
        <div class="text-center">
          <div class="capital-label-wrapper">
            <!-- CAPITAL LABEL -->
            <span class="capital-label">WE SERVE FROM SELECTION, SOURCING UNTIL DELIVERY</span>
            <!-- CAPITAL LABEL -->
          </div>

          <!-- SECTION TITLE -->
          <h1 class="section-title h2 text-black f-44 pt-1 h2-caslon">Services</h1>
          <!-- SECTION TITLE -->
        </div>
      </div>

      <div class="row m-0 pt-2">
        <div class="col-12">

          <div class="row m-0">
            <div class="col-12 col-md-6 p-0">
              <div class="content">
                <!-- PRODUCT CARD -->
                <div class="product-card">
                  <div class="product-card-image">
                    <a href="/th/plastics/services/material-selection-products-development-support">
                      <img src="/pages/products/services/material.jpg" alt="Material Selection & Products Development Support">
                    </a>
                  </div>
                  <div class="product-card-content">
                    <a href="/th/plastics/services/material-selection-products-development-support">
                      <span class="product-card-title ff-open-sans">Material Selection & Products Development Support</span>
                    </a>
                    <ul>
                      <li>Select right material at no cost</li>
                      <li>Sourcing from global manufacturer</li>
                      <li>All about plastics consult</li>
                    </ul>
                  </div>
                </div>
                <!-- PRODUCT CARD -->
              </div>
            </div>

            <div class="col-12 col-md-6 p-0">
              <div class="content">
                <!-- PRODUCT CARD -->
                <div class="product-card">
                  <div class="product-card-image">
                    <a href="/th/plastics/services/co2-calculation-visualization-service-by-zero-board">
                      <img src="/pages/products/services/co2.jpg" alt="CO2 Calculation & Visualization Service by Zero Board">
                    </a>
                  </div>
                  <div class="product-card-content">
                    <a href="/th/plastics/services/co2-calculation-visualization-service-by-zero-board">
                      <span class="product-card-title">CO2 Calculation & Visualization Service by Zero Board</span>
                    </a>
                    <ul>
                      <li>Help to know your Co2 emission</li>

                    </ul>
                  </div>
                </div>
                <!-- PRODUCT CARD -->
              </div>
            </div>

          </div>

          <div class="row m-0" style="padding: 10px 0">
            <div class="col-12 col-md-6 p-0">
              <div class="content">
                <!-- PRODUCT CARD -->
                <div class="product-card">
                  <div class="product-card-image">
                    <a href="/th/plastics/services/technical-troubleshooting">
                      <img src="/pages/products/services/troub.jpg" alt="Technical Troubleshooting">
                    </a>
                  </div>
                  <div class="product-card-content">
                    <a href="/th/plastics/services/technical-troubleshooting">
                      <span class="product-card-title">Technical Troubleshooting</span>
                    </a>
                    <ul>
                      <li>We help to get perfect molding parts by professional</li>

                    </ul>
                  </div>
                </div>
                <!-- PRODUCT CARD -->
              </div>
            </div>

            <div class="col-12 col-md-6 p-0">
              <div class="content">
                <!-- PRODUCT CARD -->
                <div class="product-card">
                  <div class="product-card-image">
                    <a href="/th/plastics/services/logistics-supports">
                      <img src="/pages/products/services/logistic.jpg" alt="Logistics Supports">
                    </a>
                  </div>
                  <div class="product-card-content">
                    <a href="/th/plastics/services/logistics-supports">
                      <span class="product-card-title">Logistics Supports</span>
                    </a>
                    <ul>
                      <li>No need to invest in logistics. Let us do it.</li>
                      <li>No worry long lead time or increasing</li>
                      <li>production. We can stock.</li>
                      <li>Lower your cost by buying bigger</li>
                    </ul>
                  </div>
                </div>
                <!-- PRODUCT CARD -->
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
  </section>
  <!-- PRODUCT PAGE -->
</template>
<script setup lang="ts">
useHead({
  title:'Services - NAGASE THAILAND Engineering Plastics',
})
</script>

<style scoped>
.product-card {
  background: white;
  border-radius: 16px;
}
.product-card-title {
  font-family: 'Myriad-Pro', sans-serif;
  font-size: 21px;
  font-weight: 500;

  color: #000000B8;
  margin-bottom: 25px;
}

.product-card-content ul {
  padding: 0;
  margin-bottom: 1rem;
}

.product-card-content ul li {
  margin-left: 23px;
  letter-spacing: -.2px;
}

.capital-label {
  font-family: 'Myriad-Pro', sans-serif;
  font-size: 11px;
  letter-spacing: -.2px;
  color: #5a5d67;
}
</style>
